import React from 'react';


import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectcommunitySubscriptionsListItems } from "../../../../../redux/community-subscriptions/selector";
import { communitySubscriptions } from "../../../../../redux/community-subscriptions/action";
export default function SubscriptionsComponent({ libraryData,id }: any) {

    const dispatch = useAppDispatch()
 
     const [pageData, setPageData] = useState(1)
     const [pageSize, setPageSize] = useState(10);
   
       const subscriptionsItems = useSelector(selectcommunitySubscriptionsListItems)
       const [
           columnDefs,
           setColumnDefs
         ] = useState({});
         const createColumnDefs: any = () => {
           setColumnDefs([
             {
               field: 'Sl',
               sortable: false,
               filter: false,
               isSortLabel: true,
               headerName: 'Sl',
               cellRenderer (params: any) {
                 return parseInt(
                   params.node.id,
                   10
                 ) + 1;
               },
             },
             
                  { field: 'CommunityName', headerName: 'Community Name', searchField: 'CommunityName', filter: true,
            filterType: 'text' },
             { field: 'Email', headerName: 'E-mail' },
              { field: 'PhoneNumber', headerName: 'Phone Number'},
            { field: 'CommunityUserStatusId', headerName: 'Community UserStatus', cellRenderer: 'libraryRendererComponent',
              cellRendererParams: { library: libraryData?.result?.ApprovalStatus },},
            { field: 'IsActive', headerName: 'Is Active', cellRenderer: 'yesNoRenderer' },
   
           ]);
         }
   
   
       
       
    
           
         const fetchCommunitySubscriptions=()=>{
           dispatch(communitySubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/list`,entity:'subscriptions',jsonData:{
         
           "PageNumber": pageData,
           "PageSize": pageSize,
           "SortField": "Id",
           "SortOrder": "desc",
           
        Filters: [
          {
            FieldName: 'CommunityId',
            FilterOperatorId: 1,
            FieldValue: id,
            FieldType: 'number'
          }
        ]
           }}))
         }
       
       
    useEffect(() => {
           createColumnDefs()
           fetchCommunitySubscriptions()
    }, [pageData,pageSize])
     const handleDelete=(data: any)=>{
       dispatch(communitySubscriptions.delete({
         url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/delete`,
         entity: 'subscriptions',
         jsonData: {
           Records: [
             {
            
                   Id: data?.Id
               }
             
           ]
         }
     })).then(() => {
       dispatch(communitySubscriptions.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/subscriptions/list`,entity:'subscriptions',jsonData:{
     
       "PageNumber": pageData,
       "PageSize": pageSize,
       "SortField": "Id",
       "SortOrder": "desc",
       
   
       }}))
     });
     }
    return (
       <>
       {subscriptionsItems?.isLoading ?  <PageLoader />: 
        <Table   
     columnData={columnDefs} rowData={subscriptionsItems?.result?.items} setPageData={setPageData}
       setPageSize={setPageSize}paginationData={subscriptionsItems?.result?.pagination}/>
        
     }
     </> 
    );
   };

